export class User {
  constructor( firstName, lastName, emailAddress, phoneNumber, password, role, roleKey, mfaCode, mfaCodeSent ) {
      this.firstName = firstName;
      this.lastName = lastName;
      this.emailAddress = emailAddress;
      this.phoneNumber = phoneNumber;
      this.password = password;
      this.role = role;
      this.roleKey = roleKey;
      this.mfaCode = mfaCode
      this.mfaCodeSent = mfaCodeSent
  }
}
